<template>
<nav class="pagination-nav" v-if="disabledBackPage === false || disabledNextPage === false ">
	<ul :class="classNames">
		<!-- <li>
			<a href="#" @click.prevent="firstPage()">&laquo;</a>
		</li> -->
		<li>
			<a href="#" @click.prevent="backPage()"  v-bind:class="{ 'disabled-pagination' : disabledBackPage }">&lt;</a>
		</li>
		<li>
			<a href="#" @click.prevent="nextPage()"  v-bind:class="{ 'disabled-pagination' : disabledNextPage }">&gt;</a>
		</li>
		<!-- <li v-if="totalPagesProp !== 2 ">
			<a href="#" @click.prevent="lastPage()">&raquo;</a>
		</li> -->
	</ul>
</nav>
</template>

<script>
	export default {
		name: 'pagination',
		data() {
			return {
				session: {
					page: 1,
					results: this.itemsPerPageProp,
					filter: this.filter || '',
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
				},
			};
		},
		computed: {
			disabledBackPage() {
				if (this.session.page === 1) {
					return true;
				}
				return false;
			},
			disabledNextPage() {
				if (this.totalPagesProp <= this.session.page) {
					return true;
				}
				return false;
			},
		},
		props: {
			itemsPerPageProp: {
				type: Number,
				required: false,
				default: 20,
			},
			classNames: {
				type: String,
				required: false,
			},
			dispatchToCall: {
				type: String,
				required: true,
			},
			filter: {
				type: String,
				required: false,
				default: 'all',
			},
			totalPagesProp: {
				type: Number,
				required: true,
			},
			idCategory: {
				type: [Number, String],
				required: false,
				default: 0,
			},
		},
		methods: {
			firstPage() {
				this.emitEvent();
				this.callDispach(1, this.idCategory);
			},
			nextPage() {
				this.emitEvent();
				const pageToShow = parseInt(this.$route.query.page, 10) + 1;

				if (this.$route.query.page && (pageToShow <= Math.ceil(this.totalPagesProp))) {
					this.callDispach(pageToShow, this.idCategory);
				}
			},
			backPage() {
				this.emitEvent();

				const pageToShow = parseInt(this.$route.query.page, 10) - 1;

				if (this.$route.query.page && pageToShow >= 1) {
					this.callDispach(pageToShow, this.idCategory);
				}
			},
			lastPage() {
				this.emitEvent();

				const lastPage = Math.ceil(this.totalPagesProp / this.results);

				this.callDispach(lastPage, this.idCategory);
			},
			callDispach(pageToShow = 1, idCategory = null) {
				this.$router.push({ query: Object.assign({}, this.$route.query, { page: pageToShow }) });

				this.session.page = pageToShow;
				this.session.idCategory = parseInt(idCategory, 10);

				this.$store.dispatch(`${this.dispatchToCall}`, this.session);
			},
			emitEvent() {
				this.$emit('changePage', false);
			},

			startPageinate(idCategory = null) {
				this.session.idCategory = parseInt(idCategory, 10);
				if (!this.$route.query.page || this.$route.query.page <= 1) {
					if (this.$route.hash) {
						this.$router.push({
							query: Object.assign(
								{},
								this.$route.query,
								{ page: 1 },
								this.$route.hash = this.$route.hash,
							),
						});
					} else {
						this.$router.push({ query: Object.assign({}, this.$route.query, { page: 1 }) });
					}
					this.$store.dispatch(`${this.dispatchToCall}`, this.session);
				} else {
					this.session.page = this.$route.query.page;
					this.$store.dispatch(`${this.dispatchToCall}`, this.session);
				}
			},
		},
		mounted() {
			this.startPageinate(this.idCategory);
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/pagination/pagination.vue